"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FormatUnderlined_exports = {};
__export(FormatUnderlined_exports, {
  default: () => FormatUnderlined_default
});
module.exports = __toCommonJS(FormatUnderlined_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 14.4102C11.1901 14.4102 11.8411 14.2799 12.4531 14.0195C13.0521 13.7591 13.5794 13.4076 14.0352 12.9648C14.4909 12.5091 14.849 11.9753 15.1094 11.3633C15.3698 10.7513 15.5 10.1003 15.5 9.41016V2.75H13.4102V9.41016C13.4102 10.2174 13.1237 10.9076 12.5508 11.4805C11.9909 12.0534 11.3073 12.3398 10.5 12.3398C9.69271 12.3398 9.0026 12.0534 8.42969 11.4805C7.86979 10.9076 7.58984 10.2174 7.58984 9.41016V2.75H5.5V9.41016C5.5 10.1003 5.63021 10.7513 5.89062 11.3633C6.15104 11.9753 6.50911 12.5091 6.96484 12.9648C7.42057 13.4076 7.94792 13.7591 8.54688 14.0195C9.15885 14.2799 9.8099 14.4102 10.5 14.4102ZM4.66016 16.0898V17.75H16.3398V16.0898H4.66016Z",
      fill: "currentColor"
    }
  )
);
const SvgFormatUnderlined = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var FormatUnderlined_default = SvgFormatUnderlined;
